import React, { useEffect, useRef, useState } from 'react';
import { ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import logoBlack from '../../assets/images/logoBlack.svg';

import backgroundImg from '../../assets/images/bg-img.png';
import { clickOutside, downloadDivAsImage, getCurrentDate, numberToWords, overLayers } from '../../utils/common';
import successImg from '../../assets/images/successimg.png';
import { isEmpty } from 'lodash';
import bbpsLogo from '../../assets/images/bbpsLogo2.png';
import { useNavigate } from 'react-router-dom';
const BbpsTransactionReceipt = ({ closePop, transactionType ="g", bankDataResp, ref }) => {

	const [customCss, setCustonCss] = useState({});
	const [zoom, setZoom] = useState("zoom-0");
	const navigate = useNavigate();
	
	const heightCss = {
		height: '150px',
	};

	const handleDownloadClick = () => {
		setCustonCss({ height: 'auto' });
		setTimeout(() => {
			const divElement = document.getElementById('model');
			downloadDivAsImage(divElement, bankDataResp?.category, setCustonCss, heightCss);
		});
	};

	


	const regExpDebit = /^D/i;
	const bbpsService = ["BBPS","PREPAID_RECHARGE","WATER","ELECTRICITY"]


	useEffect(() =>{
 setZoom("zoom-1");
	},[]);

	const close = () =>{
		setZoom("zoom-0");
		setTimeout(() =>{
			closePop();
		},300)
	}


const result = [];

	if(!isEmpty(bankDataResp?.customerDetail)){
	
       try {
		
		   const obj = JSON.parse(bankDataResp?.customerDetail);
		   for (const key in obj) {
			result.push({
				label: key,
				value: obj[key],
			});
		}
	
	   } catch (error) {
		
	   }
	}
	const boxRef = useRef(null);
	useEffect(() =>{
		overLayers(true);
		clickOutside(true,boxRef,close);
	
		return(() =>{
			overLayers(false)
			clickOutside(false,boxRef,close);
		})
	
	},[]);
	
	return (
		<ModalWraper url={backgroundImg}>
			<div className={`modal modal-success modal-body-aeps ${zoom}`} id="model" ref={boxRef}>
				<div className="flex modal-header justify-between">
					<div className="logo self-center">
                  
					<img src={logoBlack} alt={'logo'} />
						<div>
							<p>Invoicing and payments</p>
							<p>powered by Pay2Mobile</p>
						</div>
					</div>

					
					  <img src={bbpsLogo} alt="bbps logo" style={{ width: '115px' }} />
					
				</div>
				<div className="modal-close" onClick={close}>
					<IconClose />
				</div>
				
				
					<div className="text-center modal-title">
						<h2 className="transactionMsg" style={{fontSize:"18px"}}>Amount</h2>
						<h3 className="amount"
					
						>₹ {bankDataResp?.amount}</h3>
						<p className="amount-text fs-sm-12">{numberToWords(bankDataResp?.amount)}</p>
					</div>
				

				
				<div className="modal-body ">
					<div className="txn-daital">
						<div className="flex justify-between txn-daital-h">
							<div></div>
							<div></div>
						</div>
						{!isEmpty(bankDataResp?.status) && (
							<div className="flex justify-between txn-desc">
								<div className="txn-desc-right fs-sm-12">
									<div>
										<span className='fs-sm-12'>Status</span>
									</div>
								</div>
								<div className="txn-desc-left fs-sm-12">
									<div>
										<span>
											<div className="detail-desc success fs-sm-12">
                                                {bankDataResp?.status?.toLowerCase() === "success"?
                                                <><img src={successImg} alt={"success"} />
												{bankDataResp?.status}</>
                                                :<span style={{color:"red"}}> {bankDataResp?.status}</span>}
												
											</div>
										</span>
									</div>
								</div>
							</div>
						)}  
						{!isEmpty(bankDataResp?.category) &&<div className="flex justify-between txn-desc">
							<div className="txn-desc-right fs-sm-12">
								<div>
									<span>Service Type</span>
								</div>
							</div>
							<div className="txn-desc-left fs-sm-12">
								<div>
									<span>{bankDataResp?.category}</span>
								</div>
							</div>
						</div>}
					
						
						{!isEmpty(bankDataResp?.transactionId) &&<div className="flex justify-between txn-desc">
							<div className="txn-desc-right fs-sm-12">
								<div>
									<span>Transaction ID</span>
								</div>
							</div>
							<div className="txn-desc-left fs-sm-12">
								<div>
									<span>{bankDataResp?.transactionId}</span>
								</div>
							</div>
						</div>}
                        {!isEmpty(bankDataResp?.refTransactionId)&&<div className="flex justify-between txn-desc">
							<div className="txn-desc-right fs-sm-12">
								<div>
									<span>B-Connect Txn ID</span>
								</div>
							</div>
							<div className="txn-desc-left fs-sm-12">
								<div>
									<span>{bankDataResp?.refTransactionId}</span>
								</div>
							</div>
						</div>}
                        {<div className="flex justify-between txn-desc">
							<div className="txn-desc-right fs-sm-12">
								<div>
									<span>CCF</span>
								</div>
							</div>
							<div className="txn-desc-left fs-sm-12">
								<div>
									<span>₹ {bankDataResp?.ccf ?? "-"}</span>
								</div>
							</div>
						</div>}
                       {!isEmpty(bankDataResp?.createdDate)&& <div className="flex justify-between txn-desc">
							<div className="txn-desc-right fs-sm-12">
								<div>
									<span>Date And Time</span>
								</div>
							</div>
							<div className="txn-desc-left fs-sm-12">
								<div>
									<span> {getCurrentDate("",bankDataResp?.createdDate,true)}</span>
								</div>
							</div>
						</div>
						}

{
							!isEmpty(result) && result.map((obj,index)=>{
                                  return(
									<div key={index} className="flex justify-between txn-desc">
							<div className="txn-desc-right fs-sm-12">
								<div>
									<span>{obj?.label}</span>
								</div>
							</div>
							<div className="txn-desc-left fs-sm-12">
								<div>
									<span>{obj?.value}</span>
								</div>
							</div>
						</div>
								  )
							})
						}

                       {!isEmpty(bankDataResp?.createdDate)&& <div className="flex justify-between txn-desc">
							<div className="txn-desc-right fs-sm-12">
								<div>
									<span>Biller Name</span>
								</div>
							</div>
							<div className="txn-desc-left fs-sm-12" style={{maxWidth:"calc(100% - 190px)"}}>
								<div style={{    whiteSpace: "break-spaces",lineBreak: "anywhere"}}>
									<span>{bankDataResp?.billerName || "-"}</span>
								</div>
							</div>
						</div>
						}


                       
					</div>
				
				</div>
				<div className="buttons center gap-10" style={{ marginTop: '40px' }}>
					<button className="button-solid center gap-6" onClick={() => handleDownloadClick('send money receipt')}>
						<i className="fa-solid fa-download"></i> Download
					</button>
					<button className="button-solid center gap-6" onClick={() => window.print()}>
						<i className="fa-solid fa-print"></i> Print
					</button>
					{bbpsService.includes(transactionType.toLocaleUpperCase()) &&  (bankDataResp?.status?.toLowerCase() !== "success") && 
					 <button className="button-solid center gap-6" onClick={() => navigate("/bbpscomplaint",{state:{state:bankDataResp}})}>
					<i className="fa-solid fa-file-circle-exclamation"></i> Complaint
					</button>}
				</div>
			</div>
		</ModalWraper>
	);
};

export default BbpsTransactionReceipt;